import { Bounce } from "react-toastify";

export const BASEURL = "https://www.cleertax.com/wp-json/cleartax/v1/";
//   "https://wordpress-1362147-5178407.cloudwaysapps.com/wp-json/cleartax/v1/";
export const toastStyle = {
  position: "top-right",
  autoClose: 1500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  transition: Bounce,
};

export const SortFunctionForTabs = (payload) => {
  const sortedArray = payload.sort((a, b) => {
    const posA = parseInt(a.position) || Infinity;
    const posB = parseInt(b.position) || Infinity;

    return posA - posB;
  });
  return sortedArray;
};
export const SortFunctionForAnswers = (payload) => {
  const sortedArray = payload.sort((a, b) => {
    const posA = parseInt(a.tab_id) || Infinity;
    const posB = parseInt(b.tab_id) || Infinity;

    return posA - posB;
  });
  return sortedArray;
};

export const staticTabs = [
  {
    tab_id: 1,
    tab_name: "REVIEW",
    questions: [],
  },
  {
    tab_id: 2,
    tab_name: "Product Reccomendations",
    questions: [],
  },
  {
    tab_id: 3,
    tab_name: "Checkout",
    isHidden: true,
    questions: [],
  },
];
